<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import ReconnectingWebSocket from "reconnecting-websocket";
  import { mapGetters } from 'vuex'
  export default {
    name: 'App',
    computed: {
      ...mapGetters([
        'userId',
        'updateMapData'
      ])
    },
    watch: {
      userId(val) {
        if(val){
          // this.webSocketinit();
        }
      }
    },
    methods: {
      // 消息ws处理
      webSocketinit() {
        let _this = this;
        window.noticeWs = new ReconnectingWebSocket(`ws:${process.env.WS_API}cc/${this.$store.getters.userId}`);
        noticeWs.onmessage = function (_msg) {
          var data = JSON.parse(_msg.data); //通知事件的数据
          console.log(data,'==================')
          let text = '';
          if(data.type == '10003' && _this.$route.path == '/waterConservancyMap/index'){ // 预警类型消息
            // 更改地图状态数据 通知一张图更新数据
            _this.$store.dispatch("SetMapDataStatus",parseFloat(_this.updateMapData)+1)
          }else if(_this.$route.path != '/waterConservancyMap/index'){
            _this.$notify({
              title: '您收到一条新的消息，注意查收'
            });
            _this.$store.dispatch("getNoticeList",{
              toId:_this.userId,
              readFlag:0,
              pageSize:100,
              pageNum:1
            })
          }
        };
        noticeWs.onerror = function (event) {
          // this.webSocketinit();
        };
      },
    },
  }
</script>

<style media="print">
@page {
  size: auto;
  margin: 3mm;
}
@media print {
  html {
    background-color: #ffffff;
    height: auto;
    margin: 0px;
  }

  body {
    border: solid 1px #ffffff;
    margin: 10mm 15mm 10mm 15mm;
  }
  #staticList table {
    table-layout: auto !important;
  }

  #staticList .el-table__header-wrapper .el-table__header {
    width: 100% !important;
    border: solid 1px #f2f2f2;
  }
  #staticList .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }
  #staticList table {
    table-layout: fixed !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue